export default __webpack_public_path__ + "static/media/linkedIn-icon.8b966abc.svg";